// extracted by mini-css-extract-plugin
export default {"DemoTitle":"_DemoTS_DemoTitle__PkSBg","DemoSubtitle":"_DemoTS_DemoSubtitle__8ymjf"};